export const IconCvApply20: {
  name: 'icon_cv_apply_20-ffe6ed9db60d'
} = {
  name: 'icon_cv_apply_20-ffe6ed9db60d'
}
